import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed } from 'vue';
import { SwiperManager } from '../SwiperManager';


export default /*#__PURE__*/_defineComponent({
  __name: 'SwiperNavigationButton',
  props: {
    swiperManager: null,
    orientation: null,
    noEffectClass: { default: 'swiper-navigation-button-visibility-hidden' },
    iconSize: { default: 11 }
  },
  setup(__props: any) {

const props = __props as { swiperManager: SwiperManager, orientation: 'up' | 'down' | 'left' | 'right', noEffectClass: string, iconSize: number }



const svgCSS = computed<string>(() => {
    return 'width: ' + props.iconSize + 'px; height: ' + props.iconSize + 'px;';
});
const slideDirection = computed<'prev' | 'next'>(() => {
    switch (props.orientation) {
    case 'left':
    case 'up':
        return 'prev';
    default:
        return 'next';
    }
});

const willClickingDoAnything = computed<boolean>(() => {
    const swiper = props.swiperManager.swiper.value;
    if (!swiper) {
        return false;
    }
    const loopMode = swiper.params && swiper.params.loop;
    if (loopMode) {
        return (!swiper.slides || swiper.slides.length < 1);
    }
    if (swiper.isBeginning && (slideDirection.value === 'prev')) {
        return true;
    }
    if (swiper.isEnd && (slideDirection.value === 'next')) {
        return true;
    }
    return false;
});

const buttonClick = () => {
    const swiper = props.swiperManager.swiper.value;
    if (swiper) {
        if (slideDirection.value === 'prev') {
            swiper.slidePrev();
        } else {
            swiper.slideNext();
        }
    }
};


return { __sfc: true,props, svgCSS, slideDirection, willClickingDoAnything, buttonClick }
}

})